<template>
  <div class="container">
    <div class="content" v-if="!isMobile">
      <sys-dialog v-show="dialogVisible" :bgi="dialogBgi" :show-close="showClose" :close-image="closeBtnImg" :showSuccess="showSuccess" :error-msg="errorMsg" @close="closeDialog" />
      <sys-loading :loading="loading" />
      <div class="form-content">
        <img class="title" alt src="../assets/Ldp/title.png" />
        <div class="form">
          <el-carousel height="150px">
            <el-carousel-item>
              <img src="../assets/Ldp/in1.jpg" alt="">
            </el-carousel-item>
            <el-carousel-item>
              <img src="../assets/Ldp/in2.jpg" alt="">
            </el-carousel-item>
            <el-carousel-item>
              <img src="../assets/Ldp/in3.jpg" alt="">
            </el-carousel-item>
            <el-carousel-item>
              <img src="../assets/Ldp/in4.jpg" alt="">
            </el-carousel-item>
          </el-carousel>
          <div class="icon-box">
            <a href="https://www.messenger.com/t/8day2021"> <img src="../assets/Ldp/Facebook.png" alt=""></a>
            <a href="https://t.me/cskh8day"> <img src="../assets/Ldp/Telegram.png" alt=""></a>
          </div>
          <div class="right-form">
            <el-tabs v-model="activeName">
              <el-tab-pane label="ĐĂNG KÝ" name="first">
                <el-form :model="regform" ref="regform" :rules="regrules" class="inputs">
                  <el-form-item prop="userName">
                    <div class="form-input">
                      <img src="../assets/Ldp/user_2.svg" />
                      <input v-model="regform.userName" @input="regform.userName = regform.userName.replace(/[^\w]/gi, '')" placeholder="Tên đăng nhập" maxlength="20" autocomplete="off" />
                    </div>
                  </el-form-item>
                  <el-form-item prop="pass">
                    <div class="form-input">
                      <img src="../assets/Ldp/lock.svg" />
                      <input v-model="regform.pass" type="password" placeholder="Mật khẩu" maxlength="10"  />
                    </div>
                  </el-form-item>
                  <el-form-item prop="checkPass">
                    <div class="form-input">
                      <img src="../assets/Ldp/lockcheck.svg" />
                      <input v-model="regform.checkPass" type="password" autocomplete="new-password" placeholder="Nhập lại mật khẩu"  />
                    </div>
                  </el-form-item>
                  <el-form-item prop="verificationCode">
                    <div class="form-input" style="width:198px;">
                      <img src="../assets/Ldp/lockcheck.svg" />
                      <input v-model="regform.verificationCode" maxlength="4" autocomplete="new-password" placeholder="Mã xác minh" />
                    </div>
                    <div class="codeImg">
                      <span @click="getVerify" v-if="codeImg" class="validateCode">
                        <img class="img" :src="codeImg" alt="code" />
                      </span>
                    </div>
                  </el-form-item>
                </el-form>
                <v-captcha
                ref="vcaptcha1"
                :dialogVisible="dialogVisible"
                :showCheck="showCheck"
                @cb="register"
                :vstyle="{ bottom: '30px', position: 'absolute' }"
                :nativeButton="{
                  width: '250px',
                  height: '70px'
                }"
              >
              <div class="submitBtn" @click="submitAction('regform',1)"> </div>
            </v-captcha>
              </el-tab-pane>
              <el-tab-pane label="ĐĂNG NHẬP" name="second">
                <el-form :model="loginform" ref="loginform" :rules="loginrules" class="inputs">
                  <el-form-item prop="userName">
                    <div class="form-input">
                      <img src="../assets/Ldp/user_2.svg" />
                      <input v-model="loginform.userName" @input="loginform.userName = loginform.userName.replace(/[^\w]/gi, '')" placeholder="Tên đăng nhập" maxlength="20" autocomplete="off" />
                    </div>
                  </el-form-item>
                  <el-form-item prop="pass">
                    <div class="form-input">
                      <img src="../assets/Ldp/lock.svg" />
                      <input v-model="loginform.pass" type="password" placeholder="Mật khẩu" maxlength="10"  />
                    </div>
                  </el-form-item>
                </el-form>
                <div class="submitBtn login" @click="submitAction('loginform',2)">
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
      <div class="right-content">
        <img class="logo" alt src="../assets/Ldp/logo.png" />
        <div class="swiper-content">
          <swiper :options="swiperOptions">
            <swiper-slide>
              <img src="../assets/Ldp/out1.png" alt="" width="100%" />
            </swiper-slide>
            <swiper-slide>
              <img src="../assets/Ldp/out2.png" alt="" width="100%" />
            </swiper-slide>
            <swiper-slide>
              <img src="../assets/Ldp/out3.png" alt="" width="100%" />
            </swiper-slide>
            <swiper-slide>
              <img src="../assets/Ldp/out4.png" alt="" width="100%" />
            </swiper-slide>
            <swiper-slide>
              <img src="../assets/Ldp/out5.png" alt="" width="100%" />
            </swiper-slide>
            <swiper-slide>
              <img src="../assets/Ldp/out6.png" alt="" width="100%" />
            </swiper-slide>
          </swiper>
          <div class="prev-btn nav-btn" slot="button-prev"></div>
          <div class="next-btn nav-btn" slot="button-next"></div>
        </div>
      </div>

    </div>
    <div class="root" v-if="isMobile">
      <div class="icon-box">
        <a href="https://www.messenger.com/t/8day2021"> <img src="../assets/Ldp/Facebook.png" alt=""></a>
        <a href="https://t.me/cskh8day"> <img src="../assets/Ldp/Telegram.png" alt=""></a>
      </div>
      <sys-dialog v-show="dialogVisible" :bgi="dialogBgi" :show-close="showClose" :close-image="closeBtnImg" :showSuccess="showSuccess" :error-msg="errorMsg" @close="closeDialog" />
      <sys-loading :loading="loading" />
      <img class="logo" alt src="../assets/Ldp/logo.png" />
      <img class="title" alt src="../assets/Ldp/title.png" />
      <swiper :options="swiperOptions">
        <swiper-slide>
          <img src="../assets/Ldp/out1.png" alt="" width="80%" />
        </swiper-slide>
        <swiper-slide>
          <img src="../assets/Ldp/out2.png" alt="" width="80%" />
        </swiper-slide>
        <swiper-slide>
          <img src="../assets/Ldp/out3.png" alt="" width="80%" />
        </swiper-slide>
        <swiper-slide>
          <img src="../assets/Ldp/out4.png" alt="" width="80%" />
        </swiper-slide>
        <swiper-slide>
          <img src="../assets/Ldp/out5.png" alt="" width="80%" />
        </swiper-slide>
        <swiper-slide>
          <img src="../assets/Ldp/out6.png" alt="" width="80%" />
        </swiper-slide>
        <swiper-slide>
          <img src="../assets/Ldp/out5.png" alt="" width="80%" />
        </swiper-slide>
        <div class="prev-btn nav-btn" slot="button-prev"></div>
        <div class="next-btn nav-btn" slot="button-next"></div>
      </swiper>

      <swiper class="swiper gallery-thumbs" :options="swiperOptionThumbs" ref="swiperThumbs">
        <swiper-slide class="slide" style="width:100px;height:100px;">
          <img src="../assets/Ldp/gallery-thumbs1.jpg" style="width:100px;height:100px;" alt="" />
        </swiper-slide>
        <swiper-slide class="slide" style="width:100px;height:100px;">
          <img src="../assets/Ldp/gallery-thumbs2.jpg" style="width:100px;height:100px;" alt="" />
        </swiper-slide>
        <swiper-slide class="slide" style="width:100px;height:100px;">
          <img src="../assets/Ldp/gallery-thumbs3.jpg" style="width:100px;height:100px;" alt="" />
        </swiper-slide>
        <div class="swiper-button-next swiper-button-white" slot="button-next">
          <div>
            <img src="../assets/Ldp/chevron-right.svg" alt="" />
          </div>
        </div>
        <div class="swiper-button-prev swiper-button-white" slot="button-prev">
          <div>
            <img src="../assets/Ldp/chevron-left.svg" alt="" />
          </div>
        </div>
      </swiper>

      <div class="form-content">
        <el-tabs v-model="activeName2">
          <el-tab-pane label="ĐĂNG KÝ" name="first">
            <el-form :model="regform" ref="regform" :rules="regrules" class="inputs">
              <el-form-item prop="userName">
                <div class="form-input">
                  <img src="../assets/Ldp/user_2.svg" />
                  <input v-model="regform.userName" placeholder="Tên đăng nhập" maxlength="20" autocomplete="off" />
                </div>
              </el-form-item>
              <el-form-item prop="pass">
                <div class="form-input">
                  <img src="../assets/Ldp/lock.svg" />
                  <input v-model="regform.pass" type="password" placeholder="Mật khẩu" maxlength="20" autocomplete="off" />
                </div>
              </el-form-item>
              <el-form-item prop="checkPass">
                <div class="form-input">
                  <img src="../assets/Ldp/lockcheck.svg" />
                  <input v-model="regform.checkPass" type="password" placeholder="Nhập lại mật khẩu" maxlength="20" autocomplete="off" />
                </div>
              </el-form-item>
              <el-form-item prop="verificationCode">
                <div class="form-input" style="margin-right: 0.2rem;">
                  <img src="../assets/Ldp/lockshield.svg" />
                  <input v-model="regform.verificationCode" maxlength="4" placeholder="Mã xác minh" autocomplete="off" />
                </div>
                <div class="codeImg">
                  <span @click="getVerify" v-if="codeImg" class="validateCode">
                    <img class="img" :src="codeImg" alt="code" />
                  </span>
                </div>
              </el-form-item>
            </el-form>
            <v-captcha
            ref="vcaptcha1"
            :dialogVisible="dialogVisible"
            :showCheck="showCheck"
            @cb="register"
            :vstyle="{ bottom: '0', position: 'absolute' }"
            :nativeButton="{
              width: '100%',
              height: '15vw'
            }"
          >
          <div class="submitBtn" @click="submitAction('regform',1)"> </div>
        </v-captcha>
          </el-tab-pane>
          <el-tab-pane label="ĐĂNG NHẬP" name="second">
            <el-form :model="loginform" ref="loginform" :rules="loginrules" class="inputs">
              <el-form-item prop="userName">
                <div class="form-input">
                  <img src="../assets/Ldp/user_2.svg" />
                  <input v-model="loginform.userName" placeholder="Tên đăng nhập" maxlength="20" autocomplete="off" />
                </div>
              </el-form-item>
              <el-form-item prop="pass">
                <div class="form-input">
                  <img src="../assets/Ldp/lock.svg" />
                  <input v-model="loginform.pass" type="password" autocomplete="new-password" placeholder="Mật khẩu" />
                </div>
              </el-form-item>
            </el-form>
            <div class="submitBtn login" @click="submitAction('loginform',2)">
            </div>

          </el-tab-pane>
        </el-tabs>

      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import md5 from "js-md5";
import {
  FORM_VALID_MESSAGE,
  CONTRACTS,
  DOMAIN_AGENT_CODE
} from "../utils/constant";
import { userRegister, userLogin, createCustomer, getCode } from "../utils/request";
import {
  encodePlatformUrl,
  isMobile,
} from "../utils/tools";
import { captcha } from "@/mixins/captcha";
export default {
  name: "LDP",
  mixins: [captcha],
  components: { swiper, swiperSlide },
  data() {
    var validateName = (rule, value, callback) => {
      if (value === "" || !value) {
        callback(new Error("Tên đăng nhập không được để trống"));
      } else {
        console.log('value', value);
        if (value.length < 4) {
          callback(new Error("4 - 20 ký tự bao gồm số và chữ"));
        }
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "" || String(value).length < 6) {
        callback(new Error("6 - 15 ký tự bao gồm số và chữ"));
      } else {
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "" || String(value).length < 6) {
        callback(new Error("6 - 15 ký tự bao gồm số và chữ"));
      } else if (value !== this.regform.pass) {
        callback(new Error("Xác nhận mật khẩu không trùng khớp!"));
      } else {
        callback();
      }
    };
    var validateverificationCode = (rule, value, callback) => {
      console.log('......validateverificationCode',value)
      if (value === "" || value == undefined) {
        callback(new Error("Mã xác minh không được để trống"));
      } else {
        callback();
      }
    };
    return {
      showClose: false,
      showSuccess: false,
      regform: {
        userName: "",
        pass: "",
        checkPass: "",
        verificationCode: "",
      },
      regrules: {
        userName: {
          validator: validateName,
          trigger: "change"
        },
        pass: {
          validator: validatePass,
          trigger: "change"
        },
        checkPass: {
          validator: validatePass2,
          trigger: "change"
        },
        verificationCode: {
          validator: validateverificationCode,
          trigger: "blur"
        },
      },
      loginform: {
        userName: "",
        pass: ""
      },
      loginrules: {
        userName: {
          validator: validateName,
          trigger: "change"
        },
        pass: {
          validator: validatePass,
          trigger: "change"
        },
      },
      swiperOptionThumbs: {
        loop: true,
        speed: 1000,
        loopedSlides: 5, // looped slides should be the same
        spaceBetween: 10,
        autoplay: {
          disableOnInteraction: false,
          delay: 3000
        },
        centeredSlides: true,
        slidesPerView: 'auto',
        touchRatio: 0.2,
        slideToClickedSlide: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      activeName: 'first',
      activeName2: 'first',
      isMobile: isMobile(),
      loading: false,
      dialogVisible: false,
      dialogBgi: require("../assets/Ldp/bgi-dialog.png"),
      closeBtnImg: require("../assets/sinh/icon-close.png"),
      contacts: CONTRACTS,
      swiperOptions: {
        speed: 1000,
        loop: false,
        autoplay: {
          disableOnInteraction: false,
          delay: 3000
        },
        effect: "slide",
        navigation: {
          nextEl: ".next-btn",
          prevEl: ".prev-btn"
        }
      },
      errorMsg: {
        title: "",
        content: ""
      },
      codeImg: ''
    };
  },
  mounted() {
    window.onresize = () => {
      this.isMobile = isMobile();
    };
    if (this.isMobile) {
      require('@/utils/rem.js')
    }
    this.getVerify();
  },
  methods: {
    getVerify() {
      getCode({}).then(res => {
        this.codeImg = res.body.data
      })
    },
    submitAction(formName, type) {
      let that = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          that.loading = true;
          // 登陆
          if (type == 2) {
            let temp = Object.assign({}, that[formName]);
            let params = {
              userName: temp.userName,
              password: md5(temp.pass)
            };
            that.login(params);
          } else {
            that.handleCheck(that.register);
            // that.register()
          }
        }
      });
    },
    login(params) {
      userLogin(params)
        .then(res => {
          if (res.data.code == 0) {
            this.setDialogMsg(
              FORM_VALID_MESSAGE.loggedTitle,
              FORM_VALID_MESSAGE.loggedMsg
            );
            this.showSuccess = true
            setTimeout(() => {
              location.href = encodePlatformUrl(
                params.userName,
                params.password
              );
            }, 5000);
          } else {
            this.showSuccess = false
            this.showClose = true
            this.setDialogMsg(FORM_VALID_MESSAGE.loginFailTitle, res.data.msg);
          }
          this.loading = false;
        })
        .catch(error => {
          this.setDialogMsg(FORM_VALID_MESSAGE.loginFailTitle, error.data);
          this.loading = false;
        });
    },
    register() {
      this.handleConfirm()
    },
    handleConfirm() {
      // params.userName = params.userName.toLowerCase();
      // params.password = md5(params.password);
      const params = {
        userName: this.regform.userName.toLowerCase().replace(/\s+/g, ""),
        password: md5(this.regform.checkPass.replace(/\s+/g, "")),
        verificationCode: this.regform.verificationCode,
        by: 1,
        inviteCode: (this.inviteCodeObj && this.inviteCodeObj[location.host]) || DOMAIN_AGENT_CODE[location.host] || "",
        link: process.env.NODE_ENV === "development" ? "8day.com" : window.location.host.replace("www.", "")
      };
      userRegister(params, this.captchaParams)
        .then(res => {
          if (res.body.code == 0) {
            this.setDialogMsg(
              FORM_VALID_MESSAGE.registerTitle,
              FORM_VALID_MESSAGE.registerMsg
            );
            this.showSuccess = true
            createCustomer(this.form);
            setTimeout(() => {
              location.href = encodePlatformUrl(
                params.userName,
                params.password
              );
            }, 5000);
          } else {
            this.getVerify();
            this.setDialogMsg(
              FORM_VALID_MESSAGE.registerFailTitle,
              res.body.msg
            );
            this.showSuccess = false
            this.showClose = true
          }
          this.loading = false;
        })
        .catch(error => {
          this.setDialogMsg(FORM_VALID_MESSAGE.registerFailTitle, error.data);
          this.loading = false;
        });
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    setDialogMsg(title, msg) {
      this.errorMsg.title = title;
      this.errorMsg.content = msg;
      this.dialogVisible = true;
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-carousel__arrow {
  display: none !important;
}
/deep/ .el-carousel__indicators--horizontal {
  display: none;
}
.gallery-thumbs {
  box-sizing: border-box;
  padding: 10px 0px;
  width: 864px;
  margin-left: 2px;
  .swiper-button-next {
    right: 0px;
  }
  .swiper-button-prev {
    left: 0px;
  }
  .swiper-button-next,
  .swiper-button-prev {
    width: 45px;
    text-align: center;
    height: 0;
    top: 26%;
    div {
      margin-top: 31px;
      height: 45px;
      border-radius: 50%;
      img {
        margin: 7px 0 0 2px;
        width: 30px;
      }
    }
  }
}
.gallery-thumbs .swiper-slide {
  height: 80px;
  // opacity: 0.4;
}

.root .swiper-container {
  width: 100%;
}
/deep/ .el-tabs__nav {
  width: 100%;
}
/deep/ .el-tabs__item {
  width: 50%;
  font-size: 18px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: var(--neutral-02, rgba(255, 255, 255, 0.5));
}
/deep/ .el-tabs__item.is-active {
  color: var(--branding-8-day-01, #00ffec);
}
/deep/ .el-tabs__active-bar {
  height: 3px;
  background-color: #00ffec;
}
.el-carousel {
  padding-top: 47px;
}
.el-carousel,
.el-carousel__item {
  width: 320px;
  height: 320px;
}
.el-carousel__container img {
  width: 320px;
  height: 320px;
}
@media only screen and (min-width: 1420px) and (max-width: 1680px) {
  .container .content .submitBtn,
  .container .content .tags .tag {
    font-size: 24px !important;
  }
}

.container {
  ::-ms-input-placeholder {
    font-size: 24px;
    color: #ffffff;
  }

  ::-webkit-input-placeholder {
    font-size: 24px;
    color: #ffffff;
  }

  .content {
    min-width: 1920px;
    height: 1080px;
    background-image: url("../assets/Ldp/bgi-pc.jpg");
    background-size: 100% 100%;
    margin: 0;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    padding: 0 10%;

    img.logo {
      width: 322px;
      margin: 0 auto;
      display: block;
      margin-top: 78px;
    }

    .form-content {
      width: 955px;
      height: 100%;
      box-sizing: border-box;
      display: flex;
      flex-flow: column;
      align-items: center;

      img.title {
        width: 80%;
        margin-top: 42px;
      }

      .form {
        display: flex;
        width: 835px;
        height: 605px;
        padding-top: 60px;
        padding-left: 67px;
        background-image: url("../assets/Ldp/form-box.png");
        background-size: 100% 100%;
        box-sizing: border-box;
        position: relative;

        /deep/ .el-form-item {
          margin-bottom: 35px;
        }
        .icon-box {
          position: absolute;
          bottom: 102px;
          text-align: center;
          width: 320px;
          img {
            margin-right: 23px;
          }
        }
        .codeImg {
          cursor: pointer;
          width: 150px;
          height: 50px;
          position: absolute;
          right: 0;
          top: 1px;
          .img {
            width: 150px;
            height: 50px;
            border-radius: 20px;
          }
        }
        /deep/ .el-form-item__error {
          color: #f7bd00;
          padding-top: 12px;
        }
        .tags {
          width: 100%;
          height: 70px;
          position: relative;
          top: 15%;
          z-index: 99;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-family: "Montserrat";
          font-size: 20px;
          color: #ffffff;

          .tag {
            width: 55%;
            height: 100%;
            line-height: 3;
            text-indent: 3em;
            cursor: pointer;
            position: relative;

            &:nth-child(1) {
              background-image: url("../assets/jump/bgi-tag-left.png");
              background-size: 100% 100%;

              &.active {
                background-image: url("../assets/jump/bgi-tag-left-active.png");
              }
            }

            &:nth-child(2) {
              text-indent: 5em;
              background-image: url("../assets/jump/bgi-tag-right.png");
              background-size: 100% 100%;

              &.active {
                background-image: url("../assets/jump/bgi-tag-right-active.png");
              }
            }
          }
        }
        .right-form {
          width: 355px;
          margin-left: 25px;
        }

        .inputs {
          width: 100%;
          height: 435px;
          background-size: 100% 100%;
          display: flex;
          flex-flow: column;
          justify-content: flex-start;
          align-items: center;
          box-sizing: border-box;
          position: relative;
        }

        .form-input {
          width: 100%;
          height: 50px;
          display: flex;
          position: relative;
          img {
            width: 16px;
            height: 16px;
            position: absolute;
            top: calc(50%);
            transform: translateY(-50%);
            left: 20px;
          }

          input {
            width: 100%;
            height: 100%;
            background: #fff;
            border-radius: 20px;
            border: none;
            outline: none;
            text-indent: 48px;
            font-size: 16px;
            color: #000;
            &::placeholder {
              color: #000;
              font-size: 16px;
            }
          }
        }

        a.error {
          display: block;
          margin: 20px;
          color: #ffffff;
          font-size: 20px;
          text-decoration: none;
        }

        .submitBtn {
          width: 250px;
          height: 70px;
          background-image: url("../assets/Ldp/bgi-btn.gif");
          background-size: 100% 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-family: Montserrat-Black;
          font-size: 23px;
          color: #ffffff;
          cursor: pointer;
          position: absolute;
          bottom: 30px;
          left: 50%;
          transform: translateX(-50%);
          &.login {
            bottom: 160px;
            background-image: url("../assets/Ldp/login.gif");
          }
        }
      }
    }

    .swiper-content {
      width: 625px;
      background-size: 100% 100%;
      position: relative;
      display: flex;
      align-items: flex-end;

      .swiper-container {
        width: 85%;
        height: 70%;
        bottom: 54px;
        left: -4px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .next-btn {
        right: -80px;
        width: 67px;
        height: 67px;
        background-image: url("../assets/Ldp/chevron-right.svg");
      }

      .prev-btn {
        left: -80px;
        width: 67px;
        height: 67px;
        background-image: url("../assets/Ldp/chevron-left.svg");
        cursor: pointer;
      }

      .nav-btn {
        position: absolute;
        top: calc(50% - 33.5px);
        cursor: pointer;
      }
    }

    /deep/ .mask-layer .modal .close-img {
      top: -32px;
      right: -32px;
      position: absolute;
      cursor: pointer;
    }
  }
}

.root {
  width: 100vw;
  padding-bottom: 20vh;
  background-image: url("../assets/Ldp/bgmobile.jpg");
  background-size: 100% 100%;
  margin: 0;
  box-sizing: border-box;
  display: flex;
  flex-flow: column;
  align-items: center;
  color: #ffffff;
  overflow: hidden;
  padding-top: 0.34rem;
  .icon-box {
    width: 90%;
    position: absolute;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.74rem;
    img {
      width: 1.2rem;
    }
  }
  .swiper-slide {
    text-align: center;
  }
  /deep/ .el-form-item__content {
    display: flex;
    justify-content: space-between;
  }
  .codeImg {
    cursor: pointer;
    width: 3.8rem;
    margin-top: 2vw;
    height: 1.4rem;
    display: flex;
    text-align: right;
    .validateCode {
      width: 3.8rem;
      height: 1.4rem;
      display: flex;

      .img {
        border-radius: 0.4rem;
        width: 3.8rem;
        height: 1.4rem;
        transform: none !important;
        position: unset !important;
      }
    }
  }

  .next-btn {
    right: 0;
    width: 67px;
    height: 67px;
    background-image: url("../assets/Ldp/chevron-right.svg");
  }

  .prev-btn {
    left: 0;
    width: 67px;
    height: 67px;
    background-image: url("../assets/Ldp/chevron-left.svg");
    cursor: pointer;
  }

  .nav-btn {
    position: absolute;
    top: calc(50% - 33.5px);
    z-index: 3;
    cursor: pointer;
  }

  ::-webkit-scrollbar {
    display: none;
  }

  ::-ms-input-placeholder {
    font-size: 1.2em;
  }

  ::-webkit-input-placeholder {
    font-size: 1.2em;
  }

  img.logo {
    width: 6rem;
  }

  img.title {
    width: 82%;
  }
  /deep/ .el-tabs__item {
    font-size: 4vw;
    &:hover {
      color: var(--branding-8-day-01, #00ffec);
    }
  }

  .form-content {
    width: 68vw;
    display: flex;
    flex-flow: column;
    align-items: center;
    .el-tabs {
      width: 100%;
    }

    .tags {
      width: 115%;
      height: 8vh;
      position: relative;
      font-family: "Montserrat-Black";
      font-size: 1em;
      color: #ffffff;
      z-index: 1;

      .tag {
        width: 50%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;

        &:nth-child(1) {
          left: 5%;
          text-indent: -3em;
          background-image: url("../assets/jump/bgi-tag-left.png");
          background-size: 100% 100%;

          &.active {
            background-image: url("../assets/jump/bgi-tag-left-active.png");
          }
        }

        &:nth-child(2) {
          right: 5%;
          text-indent: 3em;
          background-image: url("../assets/jump/bgi-tag-right.png");
          background-size: 100% 100%;

          &.active {
            background-image: url("../assets/jump/bgi-tag-right-active.png");
          }
        }
      }
    }

    .inputs {
      width: 100%;
      background-size: 100% 100%;
      display: flex;
      flex-flow: column;
      align-items: center;
      position: relative;
      box-sizing: border-box;
      padding-top: 20%;
      top: -7vh;
      z-index: 0;

      /deep/ .el-form-item__error {
        color: #f7bd00;
        padding-top: 7px;
      }

      .form-input {
        width: 100%;
        height: 1.4rem;
        display: flex;
        position: relative;
        margin-top: 2vw;
        border-radius: 0.4rem;
        background-color: #fff;
        img {
          width: 4ch;
          height: 4vw;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: 2vw;
        }

        input {
          width: 100%;
          border-radius: 0.4rem;
          border: none;
          outline: none;
          text-indent: 10vw;
          font-size: 4vw;
          color: #000;
          display: block;
          height: 100%;
          &::placeholder {
            color: #000;
            font-size: 16px;
          }
        }
      }

      a.error {
        display: block;
        margin: 20px;
        color: #ffffff;
        font-size: 20px;
        text-decoration: none;
      }
    }
    .submitBtn {
      width: 7.7rem;
      height: 2.46rem;
      background-image: url("../assets/Ldp/bgi-btn.gif");
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: Montserrat-Black;
      font-size: 1.2em;
      color: #ffffff;
      margin: 0 auto;
      margin-top: -2rem;
      &.login{
        background-image: url("../assets/Ldp/login.gif");
      }
    }
  }
}
/deep/ .el-form-item {
  width: 100%;
}
/deep/ .geetest_box_wrap .geetest_box{
  top: -159px;
}
</style>



// WEBPACK FOOTER //
// src/components/LDP.vue